module.exports = __webpack_public_path__ + "img/10.0d885b42.jpg";